import { Panel } from '@/components/Panel';
import { useAutonomy } from '@/hooks/useAutonomy';
import { ProgressBar, EmptyState, Spinner } from '@00start/ui';

const LEVEL_LABELS: Record<number, string> = { 1: 'Observe', 2: 'Fix + Stage', 3: 'Guardrailed Prod', 4: 'Full Autonomy' };
const THRESHOLDS: Record<number, number> = { 1: 3, 2: 5, 3: 999 };

export function SAEAutonomy() {
  const { categories, loading } = useAutonomy();

  return (
    <Panel title="SAE Autonomy" mobilePriority={2}>
      {loading ? (
        <div className="flex justify-center py-4"><Spinner size="sm" /></div>
      ) : categories.length === 0 ? (
        <EmptyState title="No autonomy data" description="No category data available" />
      ) : (
        <div className="grid grid-cols-2 gap-2">
          {categories.map((cat) => {
            const threshold = THRESHOLDS[cat.sae_level] || 3;
            const progress = threshold < 999 ? Math.min(100, (cat.consecutive_successes / threshold) * 100) : 100;
            const progressVariant = progress >= 80 ? 'success' : progress >= 40 ? 'warning' : 'default';
            return (
              <div key={cat.category} className="p-2 rounded-lg bg-slate-800/50">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-[10px] font-mono text-slate-400">{cat.category}</span>
                  <span className="text-[10px] font-bold text-slate-200">L{cat.sae_level}</span>
                </div>
                <p className="text-[9px] text-slate-600 mb-1">{LEVEL_LABELS[cat.sae_level] || `Level ${cat.sae_level}`}</p>
                {threshold < 999 && (
                  <ProgressBar
                    value={cat.consecutive_successes}
                    max={threshold}
                    size="sm"
                    variant={progressVariant}
                  />
                )}
                <p className="text-[9px] text-slate-600 mt-0.5">{cat.consecutive_successes}/{threshold < 999 ? threshold : '∞'}</p>
              </div>
            );
          })}
        </div>
      )}
    </Panel>
  );
}
